import { useState } from "react";
import { Page } from "../components/ui.jsx";
import { SUPPORT_EMAIL } from "../data/site.js";

// Hands off to the device mail client rather than posting anywhere — nothing
// typed here is stored by the app.
export default function Report({ back, userName }) {
  const [what, setWhat] = useState("");
  const [where, setWhere] = useState("");

  const send = () => {
    const subject = encodeURIComponent("The Room — issue report");
    const body = encodeURIComponent(
      `What happened:\n${what}\n\nWhere: ${where}\nFrom: ${userName}`,
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <Page
      back={back}
      eyebrow="Help Us Fix It"
      title="Report an issue."
      intro="Something not working, confusing, or broken? Tell us and we'll fix it. This goes straight to the CLLXTV team."
    >
      <label className="flabel">
        What happened?{" "}
        <span style={{ color: "var(--grey)", fontWeight: 400 }}>(required)</span>
      </label>
      <textarea
        className="finput"
        style={{ minHeight: 110 }}
        value={what}
        onChange={(e) => setWhat(e.target.value)}
        placeholder="Describe the problem — e.g. I tapped a GroupMe card and nothing opened."
      />

      <label className="flabel">
        Where were you?{" "}
        <span style={{ color: "var(--grey)", fontWeight: 400 }}>(page or feature)</span>
      </label>
      <input
        className="finput"
        value={where}
        onChange={(e) => setWhere(e.target.value)}
        placeholder="Calendar, myTRiBE+, Prayer Wall…"
      />

      <div style={{ marginTop: 24 }}>
        <button className="btn-post" disabled={!what.trim()} onClick={send}>
          Send report ✉️
        </button>
      </div>

      <div className="privacy-note">
        This opens your email app with the report addressed to our team — just press send.
        If nothing opens, email us directly at {SUPPORT_EMAIL}.
      </div>
    </Page>
  );
}
